import React from "react"

import ServicesSectionDesktop from "./ServicesSectionDesktop"
import ServicesSectionMobile from "./ServicesSectionMobile"

const ServicesSection = ({ section, practice, theme, highlightedField, viewMode = "", deviceType = "desktop" }) => {
  // If viewMode is explicitly set (from preview), use that to determine which component to show
  if (viewMode === "mobile") {
    return (
      <ServicesSectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  if (viewMode === "desktop") {
    return (
      <ServicesSectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  // Use server-side device detection for public pages
  if (deviceType === "mobile") {
    return (
      <ServicesSectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  // Default to desktop for desktop devices
  return (
    <ServicesSectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
  )
}

export default ServicesSection
